import {ref, reactive} from 'vue';
import { defineStore } from 'pinia'
import { useApiCall } from '@/components/composables/api'; 
import { useRouter } from "vue-router";

const initState = ()=>{
    return {
        id  :"",
        company_name  :"",
        display_company_name:"",
        company_code  :"",
        approval_status  :"",
        permissions:[],
        plan:{}, point:{},
        has_merchant:null
   }
}
export const useCompanyStore = defineStore('company', () => {
    const router = useRouter()
    const api = useApiCall()
    const selected_company = reactive(initState())
    const companies = ref()
    function setSelectedCompany (value) {
        selected_company.id = value.id
        selected_company.company_name = value.company_name
        selected_company.display_company_name = value.display_company_name
        selected_company.company_code = value.company_code
        selected_company.approval_status = value.approval_status
        selected_company.plan = value.plan
        selected_company.point = value.point?value.point:{}
        selected_company.has_merchant = value.has_merchant
        selected_company.permissions = value.permissions === undefined? [] :value.permissions
    }
   
    function getMyGroupCompanies () {
        return new Promise((resolve, reject) => {
            try {
                api.getApi("groups/myGroupCompany").then((data)=>{
                    if(data.status && data.companies.length > 0){
                        companies.value = [...data.companies]
                        let hasCompany = data.companies.find(x => x.id == selected_company.id)
                        if(hasCompany){
                            setSelectedCompany({...hasCompany})
                        }else{
                            setSelectedCompany({...data.companies[0]})
                        }
                        
                    } 
                    resolve(data)
                }) 
                
            
            } catch (error) {
                alert("getMyGroupCompanies error")

                reject(false)
            }
        })
    }
    function canFunction(func){
        if(selected_company.permissions.indexOf(`function.${selected_company.id}.${func}`)<0){
            return false
        }else{
            return true
        }
    }
    function clear(){
        Object.assign(selected_company,initState())
        companies.value = []
    }
   
    function validateCompanyPlanStatus (company_code) {
        api.getApi(`companies/${company_code}/simple`).then((data)=>{
            if(data.status ){
                if(data.company.plan_service_status != 'running'){
                    router.push({name:'plandeny',query:{company_name:data.company.display_company_name}})
                }
                
            } 
            
        }) 
    }
   
    return { selected_company,companies,
        getMyGroupCompanies,setSelectedCompany,canFunction,clear,validateCompanyPlanStatus}
},{ persist: true})
